module.exports = __webpack_public_path__ + "img/water_en.a0eb8d8e.png";